// extracted by mini-css-extract-plugin
module.exports = {"host":"AppFooter_host__1klRJ","container":"AppFooter_container__15Lf5","menu":"AppFooter_menu__1MJAm","link":"AppFooter_link__3DC7e"};